import React from 'react';

import styles from './DividerLine.module.css';

// Text content with a title at the top
const DividerLine = () => {
  return (
    <div className={styles.dividerLine} />
  );
};

export default DividerLine;
